import { REDUCER } from '../reducers/reducersConst';

/**
 * Updates the state of a request (used to disable submit buttons)
 * @param fetching
 * @returns {{type: string, fetching: boolean}}
 */
export let isFetching = (fetching = false) => {
  return {
    type: REDUCER.COMPONENTS.FETCHING,
    fetching: fetching
  };
};

/**
 * Sets the previous route location on the store
 * @param previousRoute
 * @returns {{type: string, previousRoute: string}}
 */
export let setPreviousRoute = (previousRoute = '') => {
  return {
    type: REDUCER.COMPONENTS.PREVIOUS_ROUTE,
    previousRoute: previousRoute
  };
};

/**
 * Set the state of the main application menu (open/close)
 * @param menuIsOpen
 * @returns {{type: string, fetching: boolean}}
 */
export let setMenuOpen = (menuIsOpen = false) => {
  return {
    type: REDUCER.COMPONENTS.SET_MENU_OPEN,
    menuIsOpen: menuIsOpen
  };
};

/**
 * Saves in store the active loader state
 * @param activeLoader
 * @returns {{type: string, activeLoader: boolean}}
 */
export let setActiveLoaderState = (activeLoader = false) => {
  return {
    type: REDUCER.COMPONENTS.SET_ACTIVE_LOADER,
    activeLoader
  };
};
